import React, { Component } from 'react'
import TabBar from '../../modules/TabBar'
import CardMenu from '../../modules/CardMenu'

class ButtonAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visiblePopup: false
        }
    }

    handleClickOutside(element) {
        const outsideclickListener = event => {
            if (!element.contains(event.target)) {
                removeClickListener()
            }
        }

        const removeClickListener = () => {
            this.setState({ visiblePopup: false })
            document.removeEventListener('click', outsideclickListener)
        }

        document.addEventListener('click', outsideclickListener)
    }

    opMenu = () => {
        var element = document.getElementById('button-actions')
        this.setState({ visiblePopup: true })
        this.handleClickOutside(element)
    }

    render() {
        const { visiblePopup } = this.state
        return (
            <div style={{ position: 'relative' }}>
                <button className="btn btn-sekunder" onClick={() => this.opMenu()}>
                    <i className="icn icn-left fa fa-lw fa-ellipsis-v" /> Actions
                </button>

                <div
                    style={{ top: "45px", width: "280px" }}
                    id="button-actions"
                    className={visiblePopup ? "app-menu-popup" : "app-menu-popup app-menu-popup-hide"}>
                    <div className="content">
                        <div style={{ paddingTop: 10, paddingBottom: 10 }} className="border-bottom">
                            <CardMenu data={[{ title: 'Add Multiple Users', enableIcon: false, link: '' },]} />
                        </div>
                        <div style={{ paddingTop: 10, paddingBottom: 10 }} className="border-bottom">
                            <CardMenu data={[{ title: 'Import Contacts', enableIcon: false, link: '' },]} />
                        </div>
                        <div style={{ paddingTop: 10, paddingBottom: 10 }} className="border-bottom">
                            <CardMenu data={[
                                { title: 'Manage User Roles', enableIcon: false, link: '' },
                                { title: 'Manage Password Requirements', enableIcon: false, link: '' }
                            ]} />
                        </div>
                        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <CardMenu reverseIcon={true} data={[
                                { title: 'Find Duplicates', enableIcon: true, icon: 'fa fa-lw fa-user', link: '' },
                                { title: 'Export CSV', enableIcon: true, icon: 'fa fa-lw fa-download', link: '' }
                            ]} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class CardHeader extends Component {
    render() {
        return (
            <div className="padding-15px display-flex space-between">
                <div className="width width-40">
                    <div className="txt-site txt-10 txt-main txt-bold">Name</div>
                </div>
                <div className="width width-7">
                    <div className="txt-site txt-10 txt-main txt-bold">Group</div>
                </div>
                <div className="width width-10">
                    <div className="txt-site txt-10 txt-main txt-bold">User Type / Role</div>
                </div>
                <div className="width width-12">
                    <div className="txt-site txt-10 txt-main txt-bold">Logins</div>
                </div>
                <div className="width width-5">
                    <div className="txt-site txt-10 txt-main txt-bold"></div>
                </div>
            </div>
        )
    }
}

class CardVehicle extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div className="padding-15px display-flex space-between">
                <div className="width width-40">
                    <div className="display-flex">
                        <div style={{ width: 50, marginRight: 15 }}>
                            <div className="image image-50px background-blue" style={{ overflow: 'hidden', borderRadius: "30px" }}>
                                <img style={{ backgroundSize: "cover" }} src="https://i.pinimg.com/originals/c3/66/16/c36616a8d1f2eb3505c49dd55d07b6a9.jpg" alt="" />
                            </div>
                        </div>
                        <div style={{ width: 'calc(100% - 65px)' }}>
                            <div className="txt-site txt-12 txt-main txt-bold" style={{ marginTop: "15px" }}>Allie Hudson</div>
                        </div>
                    </div>
                </div>
                <div className="width width-7">
                    <div className="txt-site txt-10 txt-main txt-bold">Admin</div>
                </div>
                <div className="width width-10">
                    <i className="fa fa-lw fa-cog" />
                    <span className="txt-site txt-10 txt-main txt-bold margin-left-5px">Administrator</span>
                </div>
                <div className="width width-10">
                    <div className="txt-site txt-10 txt-main txt-bold" style={{ marginBottom: 3 }}>48 Logins</div>
                    <div className="txt-site txt-9 txt-primary">Last logged in about 4 hours ago</div>
                </div>
                <div className="width width-7">
                    <button className="btn btn-small btn-grey" style={{ height: 20 }}>
                        <i className="fa fa-lw fa-ellipsis-v" />
                    </button>
                </div>
            </div>
        )
    }
}

class UserManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            navigator: [
                { status: 'active', title: 'All' },
                { status: '', title: 'Unconfirmed' },
                { status: '', title: 'Dormant' },
                { status: '', title: 'Deactivated' },
            ]
        }
    }

    opNavigator = (e, isNumber = false) => {
        const id = isNumber ? e : Number(e.currentTarget.dataset.id)
        const { navigator } = this.state
        let nav = navigator.map((data, index) => {
            return { ...data, status: id === index ? 'active' : '' }
        })
        this.setState({ navigator: nav })
    }

    render() {
        const { navigator } = this.state
        return (
            <div className="main-content no-padding">
                <div className="padding-15px display-flex space-between background-white border-bottom">
                    <div className="width width-30">
                        <div className="post-top txt-site txt-16 txt-bold txt-main padding-top-5px">User Management</div>
                    </div>
                    <div className="width width-70 display-flex right">
                        <div style={{ marginLeft: 10 }}>
                            <ButtonAction />
                        </div>
                        <button className="btn btn-green" style={{ marginLeft: 10 }}>
                            <i className="icn icn-left fa fa-lw fa-plus" /> Add User
                        </button>
                    </div>
                </div>

                <div className="padding-15px">
                    <div style={{ width: '100%' }}>
                        <TabBar enableScroll={false} isSmall={true} data={navigator} theme={'theme-9'} onClick={(id) => this.opNavigator(id)} />
                    </div>

                    <div className="display-flex border-bottom" style={{ width: '100%', paddingTop: 15, paddingBottom: 15 }}>
                        <input
                            type="text"
                            className="txt txt-sekunder-color"
                            placeholder="Search names, email, and usernames"
                            style={{ width: 500, marginRight: 10 }}
                            required />
                        <button className="btn btn-sekunder" style={{ marginRight: 10 }}>
                            <i className="icn icn-left fa fa-lw fa-sliders-h" /> More
                        </button>
                        <button className="btn btn-main" style={{ marginRight: 15 }}>
                            <i className="icn icn-left fa fa-lw fa-search" /> Search
                        </button>
                        <div>
                            <div className="post-top txt-site txt-10 txt-main">0 filters applied</div>
                        </div>
                    </div>

                    <div className="display-flex space-between" style={{ width: '100%', paddingTop: 15, paddingBottom: 15 }}>
                        <div className="width width-50 display-flex">
                            <div style={{ marginRight: 15 }}>
                                <div className="post-top txt-site txt-10 txt-main">0 selected:</div>
                            </div>
                            <button className="btn btn-small btn-sekunder" style={{ marginRight: 5 }}>
                                Bulk Actions <i className="icn icn-right fa fa-lw fa-chevron-down" />
                            </button>
                        </div>
                        <div className="width width-50 display-flex right">
                            <button className="btn btn-small btn-sekunder">
                                Sort: First Name <i className="icn icn-right fa fa-lw fa-chevron-down" />
                            </button>
                            <div style={{ marginRight: 15, marginLeft: 15 }}>
                                <div className="post-top txt-site txt-10 txt-main">1 - 50 of 50</div>
                            </div>
                            <div className="display-flex">
                                <button className="btn btn-small btn-icn btn-sekunder">
                                    <i className="icn fa fa-lw fa-chevron-left" />
                                </button>
                                <button className="btn btn-small btn-icn btn-sekunder">
                                    <i className="icn fa fa-lw fa-chevron-right" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="card no-margin no-hover no-radius border-all">
                        <div>
                            <div className="border-bottom">
                                <CardHeader />
                            </div>
                            <div className="border-bottom">
                                <CardVehicle />
                            </div>
                            <div className="border-bottom">
                                <CardVehicle />
                            </div>
                            <div className="border-bottom">
                                <CardVehicle />
                            </div>
                            <div>
                                <CardVehicle />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default UserManagement